// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2_HQ1","buttons":"PendingPaymentAlert_buttons__1ZNoU"};